import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetWorkstations } from '@/hooks/useGetWorkstations';
import { SelectOptions } from '@/components/ui/SelectOptions';
import * as S from './styles';

interface WorkstationFormItemProps {
	disabled?: boolean;
}

const { useWatch } = Form;

export function WorkstationFormItem({ disabled = false }: Readonly<WorkstationFormItemProps>): JSX.Element {
	const organizationId: string = useWatch('organization_id');
	const companyId: string = useWatch('company_id');
	const sectorId: string = useWatch('sector_id');
	const lineId: string = useWatch('line_id');

	const { isLoading, data: workstations = [] } = useGetWorkstations({
		organization_id: organizationId,
		company_id: companyId,
		sector_id: sectorId,
		line_id: lineId
	});

	const isDisabled = disabled || !organizationId || !companyId || !sectorId || !lineId;
	const showLoading = !!organizationId && !!companyId && !!lineId && !!sectorId && isLoading;

	return (
		<S.CustomFormItem name="workstation_id" label={I18n.get('Workstation')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				loading={showLoading}
				disabled={isDisabled}
				options={workstations}
				placeholder={I18n.get('Workstation')}
			/>
		</S.CustomFormItem>
	);
}
